import React, { useEffect, useState } from "react";
import { useGet } from "seed/api";
import { Loading } from "seed/helpers";
import View from "components/presentation/history/chats/ChatHistory.view";

function ChatHistory({ 
  flow, 
  chat,
  isAdmin,
  refreshKey,
  onClickChangeChat 
}) {

  const userId = sessionStorage.getItem("id");
  const pageSize = 15;
  const [pageNum, setPageNum] = useState(1);

  const reqChats = useGet("/chats/get_history", {
    flow_id: flow.id,
    page_num: pageNum,
    page_size: pageSize,
    user_id: isAdmin ? null : userId,
  });

  useEffect(() => {
    reqChats.refetch();
  }, [refreshKey, pageNum]);


  if (reqChats.loading) return <Loading />
  if (reqChats.error) return ""

  const { chats = [], totalPages = 0 } = reqChats.data;

  return (
    <View
      chats={chats}
      chat={chat}
      pageNum={pageNum}
      totalPages={totalPages}
      setPageNum={setPageNum}
      onClickChangeChat={onClickChangeChat}
    />
  );

}

export default ChatHistory;